import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Breadcrumbs extends Component {
    
    render() {
        
        let config =  	this.props.config;
        let path =  	this.props.path;

        //let currentCategory = config.categories.find(h => h.path === path.substring(1));
        let currentCategory = config.categories.find(h => h.path === path.split('/').slice(-1)[0]);
  		return (

            <div className="breadcrumbs">  
                <span className="link"><a href="/"><Link to={process.env.REACT_APP_PUBLIC_URL} >Home</Link></a></span> / <span className="link current">{currentCategory.title}</span>
            </div>
          
  		)
  	}
}

export default Breadcrumbs;
